var PageModules = require('./lib/page-modules');

window.onload = function() {
  PageModules();
}